<template>
  <v-card>
    <v-card-title>
      <div>
        <div class="headline">Permitted Credit Card List</div>
      </div>
      <v-spacer></v-spacer>
      <v-flex xs6>
        <v-text-field append-icon="mdi-magnify" label="Search" single-line hide-details v-model="search"></v-text-field>
      </v-flex>
    </v-card-title>
    <v-data-table v-bind:headers="headers" v-bind:items="items" v-bind:search="search" :rows-per-page-items="itemsPerPage" v-bind:pagination.sync="pagination" item-key="cardListCode" :loading="loading" :no-data-text="noDataText" :filter="customSearch">
      <template slot="items" slot-scope="props">
        <td>{{ props.item.cardListCode }}</td>
        <td class="text-xs-left">{{ props.item.cardListDesc }}</td>
      </template>
    </v-data-table>
  </v-card>
</template>

<script>
import * as TableConst from '@/mixins/table'
import { expandURI } from '@/utils/ajax'

export default {
  data() {
    return {
      headers: [
        { text: 'Card List Code', align: 'left', value: 'cardListCode', sortable: false },
        { text: 'Card List Description', align: 'left', value: 'cardListDesc', sortable: false }
      ],
      totalItems: 0,
      loading: false,
      items: []
    }
  },
  methods: {
    async doInit() {
      await this.queryPromotionCreditCards()
    },
    async queryPromotionCreditCards() {
      const apiURI = this.$store.state.promotionManagement.promotion.menu.promotionCreditCards
      if (apiURI) {
        try {
          this.loading = true
          const expand = {
            promotion: this.promotion
          }
          const result = await this.$http.get(expandURI(apiURI, expand))
          if (result.data) {
            this.totalItems = result.data.totalElements
            const { data } = result.data
            if (data) {
              // Format the data here
              this.items = []
              data.map((promotionCreditCard) => {
                const convertPromotionCreditCard = {
                  promotion: promotionCreditCard.promotion,
                  promotionDesc: promotionCreditCard.promotionDesc,
                  cardListCode: promotionCreditCard.cardListCode,
                  cardListDesc: promotionCreditCard.cardListDesc
                }
                this.items.push(convertPromotionCreditCard)
              })
            } else {
              this.items = []
            }
          }
          this.loading = false
        } catch (err) {
          throw err
        }
      } else {
        this.$snotify.error('Invalid API URL')
      }
    }
  },
  props: {
    promotion: {
      type: String,
      default: ''
    }
  },
  created() {
    this.doInit()
  },
  mixins: [
    TableConst.default
  ]
}
</script>

<style lang="scss">
</style>
